// src/App.js
import React, { useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import NavBar from "./components/navBar";
import Footer from "./components/Footer";
import ContactUsModal from "./components/ContactUsModal";
import HelpModal from "./components/HelpModal";
import MainSection from "./components/MainSection";
import FaqSection from "./components/FaqSection";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import P2PShowcase from "./components/P2PShowcase";
import PredictionShowcase from "./components/PredictionShowcase";
import LeaderboardShowcase from "./components/LeaderboardShowcase";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Admin from "./pages/Admin";
import AdminLogin from "./admin/AdminLogin";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminPortalRedirect from "./components/AdminPortalRedirect";
import AppShell from "./app/AppShell";
import { shouldUseAdminRoutes } from "./utils/adminHost";
import GeoGate from "./components/GeoGate";
import NetworkStatusBanner from "./components/NetworkStatusBanner";
import DownloadApp from "./pages/DownloadApp";

function AdminHostRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

function MainSiteRoutes() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/app/login" replace />} />
      <Route path="/app/*" element={<AppShell />} />
      <Route path="/admin/*" element={<AdminPortalRedirect />} />
      <Route path="/bet-house" element={<Navigate to="/p2p" replace />} />
      <Route path="/p2p" element={<P2PShowcase />} />
      <Route path="/predictions" element={<PredictionShowcase />} />
      <Route path="/tips" element={<Navigate to="/predictions" replace />} />
      <Route path="/leaderboard" element={<LeaderboardShowcase />} />
      <Route
        path="*"
        element={
          <>
            <NavBar onContactUsClick={() => setIsContactModalOpen(true)} />
            <Routes>
              <Route path="/" element={<MainSection />} />
              <Route path="/faq" element={<FaqSection />} />
              <Route path="/download" element={<DownloadApp />} />
              <Route path="/android" element={<Navigate to="/download" replace />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/terms-of-service" element={<Navigate to="/terms" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <ContactUsModal
              isOpen={isContactModalOpen}
              onClose={() => setIsContactModalOpen(false)}
            />
            <HelpModal
              isOpen={isHelpModalOpen}
              onClose={() => setIsHelpModalOpen(false)}
            />
            <Footer onOpenHelpModal={() => setIsHelpModalOpen(true)} />
          </>
        }
      />
    </Routes>
  );
}

function App() {
  const location = useLocation();
  const onAdminHost = shouldUseAdminRoutes(location.pathname);

  return (
    <GeoGate>
      <NetworkStatusBanner />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />

      {onAdminHost ? <AdminHostRoutes /> : <MainSiteRoutes />}
    </GeoGate>
  );
}

export default App;
